import $ from 'jquery';

import './base.scss';
import './load-image';

$(document).ready(() => {
  $('body').attr('ontouchstart', '');
});

$(window).on('load', () => {
  $('img').loadImage();
});



// WEBPACK FOOTER //
// ./styleguide/src/assets/base/base.js